import { render, staticRenderFns } from "./ElementEditSubelementsTab.vue?vue&type=template&id=7e65b3ff"
import script from "./ElementEditSubelementsTab.vue?vue&type=script&lang=ts"
export * from "./ElementEditSubelementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports